import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useBlocker } from 'react-router';
import classnames from 'classnames';
import HeaderLogo from 'components/HeaderLogo';

import styles from './OnboardingLayout.module.scss';

export default function OnboardingLayout({ children, classes, promptEnabled }) {
  // Handle React Router navigation
  const blocker = useBlocker(
    promptEnabled
      ? ({ currentLocation, nextLocation }) =>
          currentLocation.pathname !== nextLocation.pathname
      : false,
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const proceed = window.confirm(
        'Your progress will be lost if you leave this page.',
      );
      if (proceed) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker]);

  useEffect(() => {
    window.onbeforeunload = promptEnabled ? () => true : null;
    return () => {
      window.onbeforeunload = null;
    };
  }, [promptEnabled]);

  return (
    <div className={classnames(styles.page, classes.pageContainer)}>
      <div className={styles.logoWrap}>
        <HeaderLogo />
      </div>
      <div className={classnames(styles.content, classes.pageContent)}>
        {children}
      </div>
    </div>
  );
}

OnboardingLayout.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    pageContainer: PropTypes.string,
    pageContent: PropTypes.string,
  }),
  promptEnabled: PropTypes.bool,
};

OnboardingLayout.defaultProps = {
  children: null,
  classes: {
    pageContainer: '',
    pageContent: '',
  },
  promptEnabled: true,
};
